import React from 'react';
import { useParams } from 'react-router-dom';
import CommunicationsTab from './CommunicationsTab';
import { CommunicationsProvider } from './context';

const CommunicationsTabWithProvider = () => {
  const { contactId } = useParams();

  return (
    <CommunicationsProvider contactId={contactId}>
      <CommunicationsTab />
    </CommunicationsProvider>
  );
};

export default CommunicationsTabWithProvider;
